let inputIdCounter = 0;

export class BaseHandler {
  protected el: HTMLElement;
  protected wrapper: Element;

  constructor(el: HTMLElement) {
    this.el = el;
    this.wrapper = this.getWrapper() as Element;
  }

  getWrapper(): Element | null {
    return this.el.closest('.field-wrapper') || this.el.parentElement;
  }

  showError(message: string): void {
    this.removeSuccess();
    this.wrapper.classList.add('with-error');

    const inputId = this.el.id || `input-${++inputIdCounter}`;
    if (!this.el.id) this.el.id = inputId;

    const errorId = `error-${inputId}`;
    this.el.setAttribute('aria-describedby', errorId);

    const errorContainer = this.wrapper.querySelector('.validation-result .error-message');
    if (errorContainer) {
      errorContainer.innerHTML = `<span id="${errorId}" class="error"></span>`;
      (errorContainer.firstElementChild as HTMLElement).textContent = message;
    }
  }

  removeError(): void {
    this.wrapper.classList.remove('with-error');
    this.el.removeAttribute('aria-describedby');

    const errorContainer = this.wrapper.querySelector('.validation-result .error-message');
    if (errorContainer) errorContainer.innerHTML = '';
  }

  showSuccess(): void {
    this.removeError();
    const input = this.el as HTMLInputElement;
    if (input.type === 'radio' || input.type === 'checkbox' || input.name === 'captcha') {
      return;
    }

    this.wrapper.classList.add('success');
  }

  removeSuccess(): void {
    this.wrapper.classList.remove('success');
  }
}
